export default {
    data () {
        return {
          assetTypes: [],
          userCSRFToken: '',
        }
    },
  computed: {
    requestHeaders() {
      return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.userCSRFToken,
      }
    },
  },
    methods: {
      async getAssetTypes(category) {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/asset/types/' + category, {
          credentials: "include"
        })
        const response_json = await response.json();
        // Set asset types
        this.assetTypes = response_json.types;
      },
      async requestGetCSRFtoken() {
        // Fetch session token
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'session/token', {
          credentials: "include",
        })
        // Set CSRF token
        this.userCSRFToken = await response.text();
      },
    }
};
